var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotePencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NotePencil",
    clipPath: "url(#clip0_0_101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.9362 23.6703H14.2022V18.9362L28.4043 4.73411L33.1383 9.46815L18.9362 23.6703Z",
    stroke: "var(--stroke-0, #DEDEDE)",
    strokeWidth: 1.67084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.8537 8.28458L29.5878 13.0186",
    stroke: "var(--stroke-0, #DEDEDE)",
    strokeWidth: 1.67084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.9548 18.9362V30.7713C31.9548 31.0852 31.8301 31.3862 31.6082 31.6082C31.3862 31.8301 31.0852 31.9548 30.7713 31.9548H7.10115C6.78726 31.9548 6.48623 31.8301 6.26428 31.6082C6.04233 31.3862 5.91764 31.0852 5.91764 30.7713V7.10111C5.91764 6.78723 6.04233 6.4862 6.26428 6.26424C6.48623 6.04229 6.78726 5.9176 7.10115 5.9176H18.9362",
    stroke: "var(--stroke-0, #DEDEDE)",
    strokeWidth: 1.67084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.8723,
    height: 37.8723,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotePencil);
export default __webpack_public_path__ + "static/media/note-pencil.d68057552b1568d6f4b6885e06423f61.svg";
export { ForwardRef as ReactComponent };